import React from 'react';
export function PrivacyPolicyContent() {
  return <div className="prose prose-sm max-w-none text-[#2E2E2E]" data-id="element-65">
      <p className="text-sm text-gray-500 mb-4" data-id="element-66">
        Effective Date: January 1, 2024
      </p>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-67">
        1. Information We Collect
      </h3>
      <p className="mb-4" data-id="element-68">
        At finance-time.net, we collect information necessary to provide you
        with credit score insights and recommendations. This includes:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-69">
        <li data-id="element-70">
          Personal identification information (name, email address, phone
          number)
        </li>
        <li data-id="element-71">Financial information necessary to check your credit score</li>
        <li data-id="element-72">Usage data and analytics to improve our services</li>
      </ul>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-73">
        2. How We Use Your Information
      </h3>
      <p className="mb-4" data-id="element-74">We use the information we collect to:</p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-75">
        <li data-id="element-76">
          Provide you with your credit score and personalized recommendations
        </li>
        <li data-id="element-77">Send you important updates about your credit health</li>
        <li data-id="element-78">Improve our services and user experience</li>
        <li data-id="element-79">Comply with legal obligations</li>
      </ul>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-80">
        3. Information Sharing
      </h3>
      <p className="mb-4" data-id="element-81">
        We do not sell your personal information. We may share your information
        with:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-82">
        <li data-id="element-83">Credit bureaus to retrieve your credit score</li>
        <li data-id="element-84">Service providers who help us operate our platform</li>
        <li data-id="element-85">Legal authorities when required by law</li>
      </ul>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-86">4. Data Security</h3>
      <p className="mb-4" data-id="element-87">
        We implement industry-standard security measures to protect your
        personal information, including encryption, secure servers, and regular
        security audits.
      </p>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-88">5. Your Rights</h3>
      <p className="mb-4" data-id="element-89">You have the right to:</p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-90">
        <li data-id="element-91">Access your personal information</li>
        <li data-id="element-92">Request corrections to your data</li>
        <li data-id="element-93">Delete your account and associated data</li>
        <li data-id="element-94">Opt-out of marketing communications</li>
      </ul>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-95">
        6. Cookies and Tracking
      </h3>
      <p className="mb-4" data-id="element-96">
        We use cookies and similar technologies to enhance your experience,
        analyze site usage, and deliver personalized content.
      </p>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-97">7. Contact Us</h3>
      <p className="mb-4" data-id="element-98">
        If you have questions about this Privacy Policy, please contact us at
        privacy@finance-time.net
      </p>
    </div>;
}
export function ContactUsContent() {
  return <div className="prose prose-sm max-w-none text-[#2E2E2E]" data-id="element-99">
      <p className="mb-6" data-id="element-100">
        We're here to help! If you have any questions, concerns, or feedback
        about our credit score services, please don't hesitate to reach out.
      </p>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-101">Customer Support</h3>
      <div className="bg-gray-50 p-4 rounded-lg mb-6" data-id="element-102">
        <p className="mb-2" data-id="element-103">
          <strong data-id="element-104">Email:</strong> support@finance-time.net
        </p>
        <p className="mb-2" data-id="element-105">
          <strong data-id="element-106">Phone:</strong> 1-800-CREDIT-9 (1-800-273-3489)
        </p>
        <p className="mb-2" data-id="element-107">
          <strong data-id="element-108">Hours:</strong> Monday - Friday, 9:00 AM - 6:00 PM EST
        </p>
      </div>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-109">General Inquiries</h3>
      <div className="bg-gray-50 p-4 rounded-lg mb-6" data-id="element-110">
        <p className="mb-2" data-id="element-111">
          <strong data-id="element-112">Email:</strong> info@finance-time.net
        </p>
      </div>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-113">
        Privacy & Data Requests
      </h3>
      <div className="bg-gray-50 p-4 rounded-lg mb-6" data-id="element-114">
        <p className="mb-2" data-id="element-115">
          <strong data-id="element-116">Email:</strong> privacy@finance-time.net
        </p>
        <p className="text-sm text-gray-600" data-id="element-117">
          For data access, correction, or deletion requests
        </p>
      </div>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-118">Mailing Address</h3>
      <div className="bg-gray-50 p-4 rounded-lg mb-6" data-id="element-119">
        <p className="mb-1" data-id="element-120">finance-time.net</p>
        <p className="mb-1" data-id="element-121">123 Financial Plaza, Suite 500</p>
        <p className="mb-1" data-id="element-122">New York, NY 10001</p>
        <p data-id="element-123">United States</p>
      </div>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-124">Response Time</h3>
      <p className="mb-4" data-id="element-125">
        We strive to respond to all inquiries within 24-48 hours during business
        days. For urgent matters, please call our phone support line.
      </p>
      <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mt-6" data-id="element-126">
        <p className="text-sm" data-id="element-127">
          <strong data-id="element-128">Note:</strong> For the fastest response regarding your credit
          score or account, please log in to your account and use the in-app
          support feature.
        </p>
      </div>
    </div>;
}
export function TermsOfUseContent() {
  return <div className="prose prose-sm max-w-none text-[#2E2E2E]" data-id="element-129">
      <p className="text-sm text-gray-500 mb-4" data-id="element-130">
        Last Updated: January 1, 2024
      </p>
      <p className="mb-6" data-id="element-131">
        Welcome to finance-time.net. By accessing or using our services, you
        agree to be bound by these Terms of Use.
      </p>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-132">
        1. Acceptance of Terms
      </h3>
      <p className="mb-4" data-id="element-133">
        By accessing finance-time.net, you agree to comply with and be bound by
        these Terms of Use and our Privacy Policy. If you do not agree to these
        terms, please do not use our services.
      </p>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-134">2. Services Provided</h3>
      <p className="mb-4" data-id="element-135">
        finance-time.net provides credit score checking services and
        personalized recommendations to help you improve your credit health. Our
        services include:
      </p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-136">
        <li data-id="element-137">Free credit score checks</li>
        <li data-id="element-138">Credit improvement recommendations</li>
        <li data-id="element-139">Educational resources about credit management</li>
        <li data-id="element-140">Alerts about changes to your credit profile</li>
      </ul>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-141">
        3. User Responsibilities
      </h3>
      <p className="mb-4" data-id="element-142">You agree to:</p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-143">
        <li data-id="element-144">Provide accurate and complete information</li>
        <li data-id="element-145">Maintain the confidentiality of your account credentials</li>
        <li data-id="element-146">Use our services only for lawful purposes</li>
        <li data-id="element-147">Not attempt to gain unauthorized access to our systems</li>
      </ul>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-148">
        4. Accuracy of Information
      </h3>
      <p className="mb-4" data-id="element-149">
        While we strive to provide accurate credit information, we cannot
        guarantee the accuracy, completeness, or timeliness of the information
        provided. Credit scores are obtained from third-party credit bureaus and
        may vary.
      </p>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-150">
        5. Limitation of Liability
      </h3>
      <p className="mb-4" data-id="element-151">
        finance-time.net and its affiliates shall not be liable for any
        indirect, incidental, special, consequential, or punitive damages
        resulting from your use of our services.
      </p>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-152">
        6. Intellectual Property
      </h3>
      <p className="mb-4" data-id="element-153">
        All content on finance-time.net, including text, graphics, logos, and
        software, is the property of finance-time.net and is protected by
        copyright and trademark laws.
      </p>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-154">7. Third-Party Links</h3>
      <p className="mb-4" data-id="element-155">
        Our services may contain links to third-party websites. We are not
        responsible for the content or practices of these external sites.
      </p>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-156">8. Termination</h3>
      <p className="mb-4" data-id="element-157">
        We reserve the right to terminate or suspend your access to our services
        at any time, without notice, for conduct that we believe violates these
        Terms of Use or is harmful to other users.
      </p>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-158">9. Changes to Terms</h3>
      <p className="mb-4" data-id="element-159">
        We may modify these Terms of Use at any time. Continued use of our
        services after changes constitutes acceptance of the modified terms.
      </p>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-160">10. Governing Law</h3>
      <p className="mb-4" data-id="element-161">
        These Terms of Use shall be governed by and construed in accordance with
        the laws of the State of New York, without regard to its conflict of law
        provisions.
      </p>
      <h3 className="text-xl font-semibold mt-6 mb-3" data-id="element-162">
        11. Contact Information
      </h3>
      <p className="mb-4" data-id="element-163">
        If you have questions about these Terms of Use, please contact us at
        legal@finance-time.net
      </p>
    </div>;
}